import { useParams, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { getProductById } from "@/mocks/products";
import ProductDetailHero from "./components/ProductDetailHero";
import FeaturesSection from "./components/FeaturesSection";
import ScreenshotsGallery from "./components/ScreenshotsGallery";
import UseCasesSection from "./components/UseCasesSection";
import IntegrationsSection from "./components/IntegrationsSection";
import CrossLinkSection from "./components/CrossLinkSection";
import BenefitsSection from "./components/BenefitsSection";
import ProductCTA from "./components/ProductCTA";
import ProductStructuredData from "./components/ProductStructuredData";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function ProductDetailPage() {
  const { productId } = useParams<{ productId: string }>();
  const product = productId ? getProductById(productId) : undefined;

  usePageMeta(
    product ? `${product.name} | StackMap Systems` : "Product | StackMap Systems",
    product
      ? `Learn about ${product.name}: features, integrations, use cases, and benefits. Part of the StackMap operational infrastructure platform.`
      : "Explore StackMap's operational SaaS products built for scale."
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [productId]);

  if (!product) {
    return <Navigate to="/products" replace />;
  }

  return (
    <div className="min-h-screen bg-graphite-900">
      <ProductStructuredData product={product} />
      <Navbar />
      <main>
        <ProductDetailHero product={product} />
        <FeaturesSection product={product} />
        <ScreenshotsGallery product={product} />
        <UseCasesSection product={product} />
        <IntegrationsSection product={product} />
        <CrossLinkSection productId={product.id} />
        <BenefitsSection product={product} />
        <ProductCTA productName={product.name} />
      </main>
      <Footer />
    </div>
  );
}